export const _getUnit = measure => (measure.match(/[^\d.-]/g) || []).join('');

const validateLength = (integer, originalMeasure) => {
  if (Number.isNaN(integer)) {
    throw new Error(`${originalMeasure} is not a valid measure`);
  }
};

const validateUnits = (firstUnit, secondUnit) => {
  if (secondUnit && firstUnit !== secondUnit) {
    throw new Error(`Measures ${firstUnit} and ${secondUnit} must be the same`);
  }
};

const splitMeasure = measure => {
  const unit = _getUnit(measure);

  const length = parseFloat(measure);
  validateLength(length, measure);
  return [unit, length];
};

const measureNumberAction = (measure, operandMeasure, func) => {
  const [initialUnit, initialLength] = splitMeasure(measure);

  if (typeof operandMeasure === 'number') {
    return func(initialLength, operandMeasure) + initialUnit;
  }

  const [operandUnit, operandLength] = splitMeasure(operandMeasure);
  validateUnits(initialUnit, operandUnit);
  return func(initialLength, operandLength) + initialUnit;
};

export const add = (measure, increase) => measureNumberAction(measure, increase, (a, b) => a + b);
export const subtract = (measure, decrease) => measureNumberAction(measure, decrease, (a, b) => a - b);
export const multiply = (measure, multiplier) => measureNumberAction(measure, multiplier, (a, b) => a * b);
export const divide = (measure, divisor) => measureNumberAction(measure, divisor, (a, b) => a / b);
export const negative = measure => `-${measure}`;